import { useSyncExternalStore } from 'react';

type KbPanelState = {
  isOpen: boolean;
  // Article the panel should open on; undefined shows the tree-only entry.
  slug?: string;
  // Market that article belongs to. The panel tree may show another market,
  // and the article must still be fetched from its own.
  market?: string;
  // Bumped by every explicit open, so asking for the same article twice
  // still moves the panel there.
  requestId: number;
};

let state: KbPanelState = { isOpen: false, requestId: 0 };

const listeners = new Set<() => void>();

const setState = (next: KbPanelState) => {
  state = next;
  listeners.forEach((listener) => listener());
};

// The agent chat will reuse this entry point to open the panel at an article.
export const openKnowledgeBase = (target?: {
  slug?: string;
  market?: string;
}) => {
  setState({
    isOpen: true,
    slug: target?.slug,
    market: target?.market,
    requestId: state.requestId + 1,
  });
};

export const closeKnowledgeBase = () => {
  setState({ isOpen: false, requestId: state.requestId });
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

export const useKbPanel = (): KbPanelState & {
  open: typeof openKnowledgeBase;
  close: typeof closeKnowledgeBase;
} => ({
  ...useSyncExternalStore(subscribe, () => state),
  open: openKnowledgeBase,
  close: closeKnowledgeBase,
});
